import { Component, Vue } from "vue-property-decorator";

@Component
export class SidebarNavDivider extends Vue {
}
export default SidebarNavDivider;